import React, { useCallback, useEffect, useRef } from 'react';

/**
 * Captures clicks outside of the children
 */
export const ClickAway: React.FC<{ onClickAway: () => void; className: string }> = ({
  onClickAway,
  children,
  className,
}) => {
  const ref = useRef(null);

  const clickListener = useCallback(
    (e: MouseEvent) => {
      if ((document as any).contains(e.target) && !(ref.current! as any).contains(e.target)) {
        onClickAway && onClickAway();
      }
    },
    [ref.current]
  );
  useEffect(() => {
    document.addEventListener('click', clickListener);
    return () => {
      document.removeEventListener('click', clickListener);
    };
  }, []);
  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
};
